import { useQuery } from '@tanstack/react-query';
import costCategoriesApi from '@/features/dashboard/costCategories/api/costCategoriesApi.ts';
import { costCategoriesApiQueryKeys } from '@/features/dashboard/costCategories/api/costCategoriesApi.queryKeys.ts';

const useGetCostCategories = (archived?: boolean) => {
  return useQuery({
    queryKey: costCategoriesApiQueryKeys.list(archived),
    queryFn: () => costCategoriesApi.getAll(archived),
    staleTime: 1000 * 60 * 5,
  });
};

export default useGetCostCategories;
